import { CircularProgress } from "@mui/material";
import makeStyles from '@mui/styles/makeStyles';
import React from "react";

interface SpinnerProps {
  style?: React.CSSProperties;
}

const useStyles = makeStyles((theme) => ({
  root_Spinner: {
    textAlign: "center",
  },
}));

export const Spinner: React.FC<SpinnerProps> = ({ style }) => {
  const classes = useStyles();
  return (
    <div className={classes.root_Spinner} style={style}>
      <CircularProgress color="secondary" />
    </div>
  );
};

export default Spinner;
